import { render, staticRenderFns } from "./TerminalDetails.vue?vue&type=template&id=509adba2&"
import script from "./TerminalDetails.vue?vue&type=script&lang=js&"
export * from "./TerminalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports